/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import CourseInfo from './CourseInfo';

/**
 * CourseInfo module exports
 */
export { CourseInfo as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CourseInfo/index.js